import type { PaymentAccountDetails } from "../context/paymentsTypes";

export const PAYMENTS_ACCOUNT_STORAGE_KEY = "glossa_payments_account_v1";
export const PAYMENTS_INVOICES_STORAGE_KEY = "glossa_payments_invoices_v1";
export const PAYMENTS_BILLING_STORAGE_KEY = "glossa_payments_billing_v1";

export const PAYMENTS_ACCOUNT_CHANGE_EVENT = "glossa-payments-account-change";

export function dispatchPaymentAccountChange(): void {
  window.dispatchEvent(new Event(PAYMENTS_ACCOUNT_CHANGE_EVENT));
}

export function getStoredPaymentAccount(): PaymentAccountDetails | null {
  try {
    const raw = localStorage.getItem(PAYMENTS_ACCOUNT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as PaymentAccountDetails;
    if (!parsed || typeof parsed.companyName !== "string") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function setStoredPaymentAccount(details: PaymentAccountDetails): void {
  localStorage.setItem(PAYMENTS_ACCOUNT_STORAGE_KEY, JSON.stringify(details));
  dispatchPaymentAccountChange();
}
